import { useTranslations } from '@dealerportal/i18n/client';
import ChatIcon from '@mui/icons-material/Chat';
import classNames from 'classnames';

/**
 * Function: FloatingButtonClosed
 *
 * Description:
 * Renders the close view of the floating action button. It displays a ChatIcon with specified styles and transition properties based on the isOpen state.
 *
 * @param {boolean} isOpen - A boolean indicating whether the floating action button is open or closed.
 *
 * @returns {JSX.Element} A JSX element representing the close view of the floating action button.
 */
const FloatingButtonClosed = ({
  isOpen = false,
  chatCallToActionLabel,
}: {
  isOpen: boolean;
  chatCallToActionLabel?: string;
}) => {
  const t = useTranslations();

  return (
    <div
      className={classNames(
        'ui-flex ui-items-center ui-z-30 ui-justify-between ui-px-5 ui-py-4 ui-text-xs ui-font-semibold',
        isOpen ? 'ui-opacity-0' : ''
      )}
    >
      <ChatIcon
        style={{
          transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1) !important',
        }}
        className={
          'ui-flex ui-items-center ui-z-30 ui-justify-center !ui-w-[18px] !ui-h-[18px] ui-transition-opacity ui-duration-300 ui-opacity-100 ui-mr-2'
        }
      />
      {chatCallToActionLabel ?? t('chat.textUs')}
    </div>
  );
};

export default FloatingButtonClosed;
